const Icon404 = () => {

    return (
        <svg width="398" height="147" viewBox="0 0 398 147" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M70.0264 140.448L70.0264 106.557M70.0264 106.557L70.0264 8.75805C70.0264 7.19567 67.983 6.60558 67.1501 7.92742L6.50522 104.168C5.85143 105.206 6.59706 106.557 7.82341 106.557L70.0264 106.557ZM70.0264 106.557L85.994 106.557" stroke="url(#paint0_linear_333_524)" strokeWidth="12.4646" strokeLinecap="round" />
            <path d="M335.652 140.448L335.652 106.557M335.652 106.557L335.652 8.75805C335.652 7.19567 333.609 6.60558 332.776 7.92742L272.131 104.168C271.478 105.206 272.223 106.557 273.45 106.557L335.652 106.557ZM335.652 106.557L351.62 106.557" stroke="url(#paint1_linear_333_524)" strokeWidth="12.4646" strokeLinecap="round" />
            <rect x="144.422" y="7.23231" width="76.3457" height="132.437" rx="31.1615" stroke="url(#paint2_linear_333_524)" strokeWidth="12.4646" />
            <defs>
                <linearGradient id="paint0_linear_333_524" x1="73.5293" y1="-1.33739" x2="2.63688" y2="110.844" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#00D2FF" />
                    <stop offset="1" stopColor="#3A7BD5" />
                </linearGradient>
                <linearGradient id="paint1_linear_333_524" x1="339.155" y1="-1.33739" x2="268.263" y2="110.844" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#00D2FF" />
                    <stop offset="1" stopColor="#3A7BD5" />
                </linearGradient>
                <linearGradient id="paint2_linear_333_524" x1="182.595" y1="1" x2="182.595" y2="145.901" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF512F" />
                    <stop offset="1" stopColor="#DD2476" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export default Icon404;